// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 400 400%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-1 {
  inset: -0.25rem;
}
.inset-0 {
  inset: 0px;
}
.inset-\\[3px\\] {
  inset: 3px;
}
.inset-\\[6px\\] {
  inset: 6px;
}
.inset-\\[9px\\] {
  inset: 9px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-4 {
  bottom: 1rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-4 {
  top: 1rem;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[800px\\] {
  height: 800px;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.max-h-60 {
  max-height: 15rem;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2 {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45 {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes float {

  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.05;
  }

  25% {
    transform: translate(10px, -20px) scale(1.1);
    opacity: 0.1;
  }

  50% {
    transform: translate(-15px, -35px) scale(1);
    opacity: 0.05;
  }

  75% {
    transform: translate(5px, -15px) scale(1.05);
    opacity: 0.08;
  }
}
.animate-float {
  animation: float 20s ease-in-out infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.-space-y-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(-1px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(-1px * var(--tw-space-y-reverse));
}
.space-x-14 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(3.5rem * var(--tw-space-x-reverse));
  margin-left: calc(3.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-\\[\\#22c55e\\] {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-\\[\\#22c55e\\]\\/10 {
  border-color: rgb(34 197 94 / 0.1);
}
.border-\\[\\#22c55e\\]\\/20 {
  border-color: rgb(34 197 94 / 0.2);
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/5 {
  border-color: rgb(255 255 255 / 0.05);
}
.bg-\\[\\#0a0a0a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a1a0a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 26 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f0f0f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 15 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f1f0f\\]\\/50 {
  background-color: rgb(15 31 15 / 0.5);
}
.bg-\\[\\#141414\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1a1a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1f1f1f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22c55e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22c55e\\]\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-\\[\\#22c55e\\]\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-\\[\\#22c55e\\]\\/5 {
  background-color: rgb(34 197 94 / 0.05);
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/95 {
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10 {
  background-color: rgb(234 179 8 / 0.1);
}
.bg-\\[radial-gradient\\(circle_at_50\\%_50\\%\\2c rgba\\(34\\2c 197\\2c 94\\2c 0\\.1\\)\\2c transparent_70\\%\\)\\] {
  background-image: radial-gradient(circle at 50% 50%,rgba(34,197,94,0.1),transparent 70%);
}
.bg-\\[radial-gradient\\(ellipse_at_top\\2c rgba\\(34\\2c 197\\2c 94\\2c 0\\.05\\)\\2c transparent_50\\%\\)\\] {
  background-image: radial-gradient(ellipse at top,rgba(34,197,94,0.05),transparent 50%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tl {
  background-image: linear-gradient(to top left, var(--tw-gradient-stops));
}
.from-\\[\\#22c55e\\] {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#22c55e\\]\\/10 {
  --tw-gradient-from: rgb(34 197 94 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#22c55e\\]\\/20 {
  --tw-gradient-from: rgb(34 197 94 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#22c55e\\]\\/30 {
  --tw-gradient-from: rgb(34 197 94 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80 {
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#15803d\\] {
  --tw-gradient-to: rgb(21 128 61 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #15803d var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#22c55e\\]\\/10 {
  --tw-gradient-to: rgb(34 197 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(34 197 94 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.05\\)\\] {
  --tw-gradient-to: rgba(34, 197, 94, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgba(34,197,94,0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#15803d\\] {
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}
.to-\\[\\#22c55e\\] {
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-\\[\\#22c55e\\]\\/5 {
  --tw-gradient-to: rgb(34 197 94 / 0.05) var(--tw-gradient-to-position);
}
.to-black\\/60 {
  --tw-gradient-to: rgb(0 0 0 / 0.6) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.text-\\[44px\\] {
  font-size: 44px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.text-\\[\\#229ED9\\] {
  --tw-text-opacity: 1;
  color: rgb(34 158 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22c55e\\] {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22c55e\\]\\/80 {
  color: rgb(34 197 94 / 0.8);
}
.text-\\[\\#5865F2\\] {
  --tw-text-opacity: 1;
  color: rgb(88 101 242 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#22c55e\\]\\/20 {
  --tw-shadow-color: rgb(34 197 94 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-800\\/20 {
  --tw-shadow-color: rgb(31 41 55 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\] {
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[120px\\] {
  --tw-blur: blur(120px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}

/* Base Styles */
body {
  --tw-bg-opacity: 1;
  background-color: rgb(10 26 10 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

/* Stars Animation Base */
.star-base {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #22c55e,
    0 0 20px #22c55e,
    0 0 30px #22c55e;
  opacity: 0;
}

/* Top Layer Stars */
.star-top {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #22c55e,
    0 0 20px #22c55e,
    0 0 30px #22c55e;
  opacity: 0;
  animation: floatTop 4s linear infinite;
}

@keyframes floatTop {
  0% {
    transform: translateY(100vh);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
}

/* Middle Layer Stars */
.star-middle {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #22c55e,
    0 0 20px #22c55e,
    0 0 30px #22c55e;
  opacity: 0;
  animation: floatMiddle 5s linear infinite;
}

@keyframes floatMiddle {
  0% {
    transform: translateY(100vh);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
}

/* Bottom Layer Stars */
.star-bottom {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 
    0 0 10px #22c55e,
    0 0 20px #22c55e,
    0 0 30px #22c55e;
  opacity: 0;
  animation: floatBottom 6s linear infinite;
}

@keyframes floatBottom {
  0% {
    transform: translateY(100vh);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
}

/* Star Positions - All Layers */
.star-top:nth-child(1) { left: 5%; animation-delay: 0s; }
.star-top:nth-child(2) { left: 10%; animation-delay: 2s; }
.star-top:nth-child(3) { left: 15%; animation-delay: 1s; }
.star-top:nth-child(4) { left: 20%; animation-delay: 3s; }
.star-top:nth-child(5) { left: 25%; animation-delay: 0.5s; }
.star-top:nth-child(6) { left: 30%; animation-delay: 2.5s; }
.star-top:nth-child(7) { left: 35%; animation-delay: 1.5s; }
.star-top:nth-child(8) { left: 40%; animation-delay: 3.5s; }
.star-top:nth-child(9) { left: 45%; animation-delay: 0.2s; }
.star-top:nth-child(10) { left: 50%; animation-delay: 2.2s; }
.star-top:nth-child(11) { left: 55%; animation-delay: 1.2s; }
.star-top:nth-child(12) { left: 60%; animation-delay: 3.2s; }
.star-top:nth-child(13) { left: 65%; animation-delay: 0.7s; }
.star-top:nth-child(14) { left: 70%; animation-delay: 2.7s; }
.star-top:nth-child(15) { left: 75%; animation-delay: 1.7s; }
.star-top:nth-child(16) { left: 80%; animation-delay: 3.7s; }
.star-top:nth-child(17) { left: 85%; animation-delay: 0.3s; }
.star-top:nth-child(18) { left: 90%; animation-delay: 2.3s; }
.star-top:nth-child(19) { left: 95%; animation-delay: 1.3s; }
.star-top:nth-child(20) { left: 98%; animation-delay: 3.3s; }

.star-middle:nth-child(1) { left: 3%; animation-delay: 0.1s; }
.star-middle:nth-child(2) { left: 8%; animation-delay: 2.1s; }
.star-middle:nth-child(3) { left: 13%; animation-delay: 1.1s; }
.star-middle:nth-child(4) { left: 18%; animation-delay: 3.1s; }
.star-middle:nth-child(5) { left: 23%; animation-delay: 0.6s; }
.star-middle:nth-child(6) { left: 28%; animation-delay: 2.6s; }
.star-middle:nth-child(7) { left: 33%; animation-delay: 1.6s; }
.star-middle:nth-child(8) { left: 38%; animation-delay: 3.6s; }
.star-middle:nth-child(9) { left: 43%; animation-delay: 0.4s; }
.star-middle:nth-child(10) { left: 48%; animation-delay: 2.4s; }
.star-middle:nth-child(11) { left: 53%; animation-delay: 1.4s; }
.star-middle:nth-child(12) { left: 58%; animation-delay: 3.4s; }
.star-middle:nth-child(13) { left: 63%; animation-delay: 0.8s; }
.star-middle:nth-child(14) { left: 68%; animation-delay: 2.8s; }
.star-middle:nth-child(15) { left: 73%; animation-delay: 1.8s; }
.star-middle:nth-child(16) { left: 78%; animation-delay: 3.8s; }
.star-middle:nth-child(17) { left: 83%; animation-delay: 0.5s; }
.star-middle:nth-child(18) { left: 88%; animation-delay: 2.5s; }
.star-middle:nth-child(19) { left: 93%; animation-delay: 1.5s; }
.star-middle:nth-child(20) { left: 97%; animation-delay: 3.5s; }

.star-bottom:nth-child(1) { left: 2%; animation-delay: 0.2s; }
.star-bottom:nth-child(2) { left: 7%; animation-delay: 2.2s; }
.star-bottom:nth-child(3) { left: 12%; animation-delay: 1.2s; }
.star-bottom:nth-child(4) { left: 17%; animation-delay: 3.2s; }
.star-bottom:nth-child(5) { left: 22%; animation-delay: 0.7s; }
.star-bottom:nth-child(6) { left: 27%; animation-delay: 2.7s; }
.star-bottom:nth-child(7) { left: 32%; animation-delay: 1.7s; }
.star-bottom:nth-child(8) { left: 37%; animation-delay: 3.7s; }
.star-bottom:nth-child(9) { left: 42%; animation-delay: 0.3s; }
.star-bottom:nth-child(10) { left: 47%; animation-delay: 2.3s; }
.star-bottom:nth-child(11) { left: 52%; animation-delay: 1.3s; }
.star-bottom:nth-child(12) { left: 57%; animation-delay: 3.3s; }
.star-bottom:nth-child(13) { left: 62%; animation-delay: 0.9s; }
.star-bottom:nth-child(14) { left: 67%; animation-delay: 2.9s; }
.star-bottom:nth-child(15) { left: 72%; animation-delay: 1.9s; }
.star-bottom:nth-child(16) { left: 77%; animation-delay: 3.9s; }
.star-bottom:nth-child(17) { left: 82%; animation-delay: 0.6s; }
.star-bottom:nth-child(18) { left: 87%; animation-delay: 2.6s; }
.star-bottom:nth-child(19) { left: 92%; animation-delay: 1.6s; }
.star-bottom:nth-child(20) { left: 96%; animation-delay: 3.6s; }

/* Noise Background */
.bg-noise {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat;
  width: 100%;
  height: 100%;
}

/* Enhanced Aurora Background Effect */
.aurora-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
  opacity: 0.5;
}

.aurora-background::before,
.aurora-background::after {
  content: '';
  position: absolute;
  width: 300%;
  height: 300%;
  top: -100%;
  left: -100%;
  background: radial-gradient(
    circle at center,
    rgba(16, 185, 129, 0.15) 0%,
    rgba(6, 148, 162, 0.15) 25%,
    rgba(5, 150, 105, 0.15) 50%,
    rgba(4, 120, 87, 0.15) 75%
  );
  animation: aurora 60s linear infinite;
  transform-origin: center center;
}

.aurora-background::after {
  animation-delay: -30s;
  animation-direction: reverse;
  opacity: 0.7;
  filter: blur(30px);
}

/* Glass Card Effect */
.glass-card {
  background: rgba(15, 31, 15, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.glass-card:hover {
  border-color: var(--primary);
  box-shadow: 0 0 15px rgba(34, 197, 94, 0.3);
}

/* Enhanced Neon Button Effect */
.neon-button {
  position: relative;
  background: linear-gradient(45deg, #22c55e, #15803d);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
  border-radius: 0.75rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  color: white;
  cursor: pointer;
}

.neon-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: all 0.6s ease;
}

.neon-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px rgba(34, 197, 94, 0.5);
}

.neon-button:hover::before {
  left: 100%;
}

.neon-button:disabled {
  background: linear-gradient(45deg, #4b5563, #6b7280);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Review Stars Effect */
.review-star {
  color: #22c55e;
  filter: drop-shadow(0 0 5px rgba(34, 197, 94, 0.5));
  transition: all 0.3s ease;
}

.review-star:hover {
  filter: drop-shadow(0 0 8px rgba(34, 197, 94, 0.8));
  transform: scale(1.1);
}

.review-star.filled {
  color: #22c55e;
  filter: drop-shadow(0 0 5px rgba(34, 197, 94, 0.5));
}

/* Enhanced Category Button Effect */
.category-button {
  background: rgba(17, 17, 17, 0.7);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.category-button:hover {
  border-color: rgba(16, 185, 129, 0.5);
  box-shadow: 0 0 15px rgba(16, 185, 129, 0.3);
}

.category-button.active {
  background: linear-gradient(45deg, #059669, #0d9488);
  border: none;
  box-shadow: 0 0 20px rgba(16, 185, 129, 0.4);
}

/* Product Page Specific Styles */
.product-image {
  border-radius: 1rem;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  transition: all 0.3s ease;
}

.product-image:hover {
  transform: scale(1.02);
}

/* Payment Page Specific Styles */
.payment-card {
  background: rgba(17, 17, 17, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
}

/* Form Inputs */
.form-input {
  background: rgba(15, 31, 15, 0.8);
  border: 1px solid rgba(34, 197, 94, 0.2);
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.2s;
}

.form-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
  outline: none;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: rgba(17, 17, 17, 0.7);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #059669, #0d9488);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(45deg, #0d9488, #059669);
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Stats Card Animation */
.stats-card {
  transition: all 0.3s ease;
  background: rgba(17, 17, 17, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.stats-card:hover {
  transform: translateY(-5px);
  border-color: rgba(16, 185, 129, 0.3);
  box-shadow: 0 8px 32px rgba(16, 185, 129, 0.2);
}

/* Social Links Animation */
.social-link {
  transition: all 0.3s ease;
}

.social-link:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* Feature Text Color */
.feature-text {
  color: #22c55e;
}

/* Price Text Color */
.price-text {
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

/* Link Color */
.link-text {
  color: #22c55e;
  transition: all 0.3s ease;
}

.link-text:hover {
  color: #15803d;
  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#22c55e\\]\\/15:hover {
  border-color: rgb(34 197 94 / 0.15);
}

.hover\\:border-\\[\\#22c55e\\]\\/20:hover {
  border-color: rgb(34 197 94 / 0.2);
}

.hover\\:border-\\[\\#22c55e\\]\\/30:hover {
  border-color: rgb(34 197 94 / 0.3);
}

.hover\\:border-gray-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#15803d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1ea34b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 163 75 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#22c55e\\]\\/10:hover {
  background-color: rgb(34 197 94 / 0.1);
}

.hover\\:bg-\\[\\#22c55e\\]\\/5:hover {
  background-color: rgb(34 197 94 / 0.05);
}

.hover\\:bg-black\\/20:hover {
  background-color: rgb(0 0 0 / 0.2);
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#15803d\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#22c55e\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-dark:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.focus\\:z-10:focus {
  z-index: 10;
}

.focus\\:border-\\[\\#22c55e\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#22c55e\\]\\/20:focus {
  border-color: rgb(34 197 94 / 0.2);
}

.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#22c55e\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[\\#22c55e\\]\\/20:focus {
  --tw-ring-color: rgb(34 197 94 / 0.2);
}

.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.group:hover .group-hover\\:animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.group:hover .group-hover\\:animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.group:hover .group-hover\\:border-\\[\\#22c55e\\]\\/40 {
  border-color: rgb(34 197 94 / 0.4);
}

.group:hover .group-hover\\:bg-\\[\\#22c55e\\]\\/10 {
  background-color: rgb(34 197 94 / 0.1);
}

.group:hover .group-hover\\:text-\\[\\#22c55e\\] {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:duration-200 {
  transition-duration: 200ms;
}

@media (min-width: 640px) {

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:w-\\[500px\\] {
    width: 500px;
  }

  .md\\:min-w-\\[190px\\] {
    min-width: 190px;
  }

  .md\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:overflow-x-auto {
    overflow-x: auto;
  }

  .md\\:pb-4 {
    padding-bottom: 1rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1024px) {

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;;EAAnB;IAAA,4CAAmB;IAAnB;EAAmB;;EAAnB;IAAA,2CAAmB;IAAnB;EAAmB;;EAAnB;IAAA,4CAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,gBAAgB;AAEd;EAAA,kBAA8B;EAA9B,yDAA8B;EAA9B,oBAA8B;EAA9B,mDAA8B;EAC9B,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC;AAP8B;;AAUhC,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;oBAGkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;oBAGkB;EAClB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;oBAGkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;oBAGkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC,yBAAyB,QAAQ,EAAE,mBAAmB,EAAE;AACxD,yBAAyB,SAAS,EAAE,mBAAmB,EAAE;AACzD,yBAAyB,SAAS,EAAE,mBAAmB,EAAE;AACzD,yBAAyB,SAAS,EAAE,mBAAmB,EAAE;AACzD,yBAAyB,SAAS,EAAE,qBAAqB,EAAE;AAC3D,yBAAyB,SAAS,EAAE,qBAAqB,EAAE;AAC3D,yBAAyB,SAAS,EAAE,qBAAqB,EAAE;AAC3D,yBAAyB,SAAS,EAAE,qBAAqB,EAAE;AAC3D,yBAAyB,SAAS,EAAE,qBAAqB,EAAE;AAC3D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;AAC5D,0BAA0B,SAAS,EAAE,qBAAqB,EAAE;;AAE5D,4BAA4B,QAAQ,EAAE,qBAAqB,EAAE;AAC7D,4BAA4B,QAAQ,EAAE,qBAAqB,EAAE;AAC7D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;;AAE/D,4BAA4B,QAAQ,EAAE,qBAAqB,EAAE;AAC7D,4BAA4B,QAAQ,EAAE,qBAAqB,EAAE;AAC7D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,4BAA4B,SAAS,EAAE,qBAAqB,EAAE;AAC9D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;AAC/D,6BAA6B,SAAS,EAAE,qBAAqB,EAAE;;AAE/D,qBAAqB;AACrB;EACE,yDAAwU;EACxU,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX;;;;;;GAMC;EACD,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,wCAAwC;EACxC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mDAAmD;AACrD;;AAEA,oCAAoC;AACpC;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;EAC5C,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA,qBAAqB;AAEnB;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B;AAA+B;;AAGjC,eAAe;AACf;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAtaA;EAAA;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,iBAsaE;EAtaF,iBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,sBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,sBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,sBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,8BAsaE;EAtaF;AAsaE;;AAtaF;EAAA,2GAsaE;EAtaF,yGAsaE;EAtaF;AAsaE;;AAtaF;EAAA,2GAsaE;EAtaF,yGAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,qBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,yBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,qBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,kBAsaE;EAtaF,kBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,iBAsaE;EAtaF,iBAsaE;EAtaF;AAsaE;;AAtaF;;EAAA;IAAA,2BAsaE;IAtaF;EAsaE;;EAtaF;IAAA,eAsaE;IAtaF;EAsaE;AAAA;;AAtaF;EAAA;AAsaE;;AAtaF;;EAAA;IAAA;EAsaE;AAAA;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA,oBAsaE;EAtaF;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;EAAA;AAsaE;;AAtaF;;EAAA;IAAA;EAsaE;;EAtaF;IAAA,oBAsaE;IAtaF;EAsaE;;EAtaF;IAAA,mBAsaE;IAtaF;EAsaE;AAAA;;AAtaF;;EAAA;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA;EAsaE;;EAtaF;IAAA,eAsaE;IAtaF;EAsaE;AAAA;;AAtaF;;EAAA;IAAA;EAsaE;;EAtaF;IAAA,kBAsaE;IAtaF;EAsaE;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Base Styles */\nbody {\n  @apply bg-[#0a1a0a] text-white;\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\n/* Stars Animation Base */\n.star-base {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: \n    0 0 10px #22c55e,\n    0 0 20px #22c55e,\n    0 0 30px #22c55e;\n  opacity: 0;\n}\n\n/* Top Layer Stars */\n.star-top {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: \n    0 0 10px #22c55e,\n    0 0 20px #22c55e,\n    0 0 30px #22c55e;\n  opacity: 0;\n  animation: floatTop 4s linear infinite;\n}\n\n@keyframes floatTop {\n  0% {\n    transform: translateY(100vh);\n    opacity: 0.8;\n  }\n  100% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n/* Middle Layer Stars */\n.star-middle {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: \n    0 0 10px #22c55e,\n    0 0 20px #22c55e,\n    0 0 30px #22c55e;\n  opacity: 0;\n  animation: floatMiddle 5s linear infinite;\n}\n\n@keyframes floatMiddle {\n  0% {\n    transform: translateY(100vh);\n    opacity: 0.8;\n  }\n  100% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n/* Bottom Layer Stars */\n.star-bottom {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: #22c55e;\n  border-radius: 50%;\n  box-shadow: \n    0 0 10px #22c55e,\n    0 0 20px #22c55e,\n    0 0 30px #22c55e;\n  opacity: 0;\n  animation: floatBottom 6s linear infinite;\n}\n\n@keyframes floatBottom {\n  0% {\n    transform: translateY(100vh);\n    opacity: 0.8;\n  }\n  100% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n/* Star Positions - All Layers */\n.star-top:nth-child(1) { left: 5%; animation-delay: 0s; }\n.star-top:nth-child(2) { left: 10%; animation-delay: 2s; }\n.star-top:nth-child(3) { left: 15%; animation-delay: 1s; }\n.star-top:nth-child(4) { left: 20%; animation-delay: 3s; }\n.star-top:nth-child(5) { left: 25%; animation-delay: 0.5s; }\n.star-top:nth-child(6) { left: 30%; animation-delay: 2.5s; }\n.star-top:nth-child(7) { left: 35%; animation-delay: 1.5s; }\n.star-top:nth-child(8) { left: 40%; animation-delay: 3.5s; }\n.star-top:nth-child(9) { left: 45%; animation-delay: 0.2s; }\n.star-top:nth-child(10) { left: 50%; animation-delay: 2.2s; }\n.star-top:nth-child(11) { left: 55%; animation-delay: 1.2s; }\n.star-top:nth-child(12) { left: 60%; animation-delay: 3.2s; }\n.star-top:nth-child(13) { left: 65%; animation-delay: 0.7s; }\n.star-top:nth-child(14) { left: 70%; animation-delay: 2.7s; }\n.star-top:nth-child(15) { left: 75%; animation-delay: 1.7s; }\n.star-top:nth-child(16) { left: 80%; animation-delay: 3.7s; }\n.star-top:nth-child(17) { left: 85%; animation-delay: 0.3s; }\n.star-top:nth-child(18) { left: 90%; animation-delay: 2.3s; }\n.star-top:nth-child(19) { left: 95%; animation-delay: 1.3s; }\n.star-top:nth-child(20) { left: 98%; animation-delay: 3.3s; }\n\n.star-middle:nth-child(1) { left: 3%; animation-delay: 0.1s; }\n.star-middle:nth-child(2) { left: 8%; animation-delay: 2.1s; }\n.star-middle:nth-child(3) { left: 13%; animation-delay: 1.1s; }\n.star-middle:nth-child(4) { left: 18%; animation-delay: 3.1s; }\n.star-middle:nth-child(5) { left: 23%; animation-delay: 0.6s; }\n.star-middle:nth-child(6) { left: 28%; animation-delay: 2.6s; }\n.star-middle:nth-child(7) { left: 33%; animation-delay: 1.6s; }\n.star-middle:nth-child(8) { left: 38%; animation-delay: 3.6s; }\n.star-middle:nth-child(9) { left: 43%; animation-delay: 0.4s; }\n.star-middle:nth-child(10) { left: 48%; animation-delay: 2.4s; }\n.star-middle:nth-child(11) { left: 53%; animation-delay: 1.4s; }\n.star-middle:nth-child(12) { left: 58%; animation-delay: 3.4s; }\n.star-middle:nth-child(13) { left: 63%; animation-delay: 0.8s; }\n.star-middle:nth-child(14) { left: 68%; animation-delay: 2.8s; }\n.star-middle:nth-child(15) { left: 73%; animation-delay: 1.8s; }\n.star-middle:nth-child(16) { left: 78%; animation-delay: 3.8s; }\n.star-middle:nth-child(17) { left: 83%; animation-delay: 0.5s; }\n.star-middle:nth-child(18) { left: 88%; animation-delay: 2.5s; }\n.star-middle:nth-child(19) { left: 93%; animation-delay: 1.5s; }\n.star-middle:nth-child(20) { left: 97%; animation-delay: 3.5s; }\n\n.star-bottom:nth-child(1) { left: 2%; animation-delay: 0.2s; }\n.star-bottom:nth-child(2) { left: 7%; animation-delay: 2.2s; }\n.star-bottom:nth-child(3) { left: 12%; animation-delay: 1.2s; }\n.star-bottom:nth-child(4) { left: 17%; animation-delay: 3.2s; }\n.star-bottom:nth-child(5) { left: 22%; animation-delay: 0.7s; }\n.star-bottom:nth-child(6) { left: 27%; animation-delay: 2.7s; }\n.star-bottom:nth-child(7) { left: 32%; animation-delay: 1.7s; }\n.star-bottom:nth-child(8) { left: 37%; animation-delay: 3.7s; }\n.star-bottom:nth-child(9) { left: 42%; animation-delay: 0.3s; }\n.star-bottom:nth-child(10) { left: 47%; animation-delay: 2.3s; }\n.star-bottom:nth-child(11) { left: 52%; animation-delay: 1.3s; }\n.star-bottom:nth-child(12) { left: 57%; animation-delay: 3.3s; }\n.star-bottom:nth-child(13) { left: 62%; animation-delay: 0.9s; }\n.star-bottom:nth-child(14) { left: 67%; animation-delay: 2.9s; }\n.star-bottom:nth-child(15) { left: 72%; animation-delay: 1.9s; }\n.star-bottom:nth-child(16) { left: 77%; animation-delay: 3.9s; }\n.star-bottom:nth-child(17) { left: 82%; animation-delay: 0.6s; }\n.star-bottom:nth-child(18) { left: 87%; animation-delay: 2.6s; }\n.star-bottom:nth-child(19) { left: 92%; animation-delay: 1.6s; }\n.star-bottom:nth-child(20) { left: 96%; animation-delay: 3.6s; }\n\n/* Noise Background */\n.bg-noise {\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\");\n  background-repeat: repeat;\n  width: 100%;\n  height: 100%;\n}\n\n/* Enhanced Aurora Background Effect */\n.aurora-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden;\n  opacity: 0.5;\n}\n\n.aurora-background::before,\n.aurora-background::after {\n  content: '';\n  position: absolute;\n  width: 300%;\n  height: 300%;\n  top: -100%;\n  left: -100%;\n  background: radial-gradient(\n    circle at center,\n    rgba(16, 185, 129, 0.15) 0%,\n    rgba(6, 148, 162, 0.15) 25%,\n    rgba(5, 150, 105, 0.15) 50%,\n    rgba(4, 120, 87, 0.15) 75%\n  );\n  animation: aurora 60s linear infinite;\n  transform-origin: center center;\n}\n\n.aurora-background::after {\n  animation-delay: -30s;\n  animation-direction: reverse;\n  opacity: 0.7;\n  filter: blur(30px);\n}\n\n/* Glass Card Effect */\n.glass-card {\n  background: rgba(15, 31, 15, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s;\n}\n\n.glass-card:hover {\n  border-color: var(--primary);\n  box-shadow: 0 0 15px rgba(34, 197, 94, 0.3);\n}\n\n/* Enhanced Neon Button Effect */\n.neon-button {\n  position: relative;\n  background: linear-gradient(45deg, #22c55e, #15803d);\n  border: none;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  border-radius: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n}\n\n.neon-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  transition: all 0.6s ease;\n}\n\n.neon-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 20px rgba(34, 197, 94, 0.5);\n}\n\n.neon-button:hover::before {\n  left: 100%;\n}\n\n.neon-button:disabled {\n  background: linear-gradient(45deg, #4b5563, #6b7280);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Review Stars Effect */\n.review-star {\n  color: #22c55e;\n  filter: drop-shadow(0 0 5px rgba(34, 197, 94, 0.5));\n  transition: all 0.3s ease;\n}\n\n.review-star:hover {\n  filter: drop-shadow(0 0 8px rgba(34, 197, 94, 0.8));\n  transform: scale(1.1);\n}\n\n.review-star.filled {\n  color: #22c55e;\n  filter: drop-shadow(0 0 5px rgba(34, 197, 94, 0.5));\n}\n\n/* Enhanced Category Button Effect */\n.category-button {\n  background: rgba(17, 17, 17, 0.7);\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.category-button:hover {\n  border-color: rgba(16, 185, 129, 0.5);\n  box-shadow: 0 0 15px rgba(16, 185, 129, 0.3);\n}\n\n.category-button.active {\n  background: linear-gradient(45deg, #059669, #0d9488);\n  border: none;\n  box-shadow: 0 0 20px rgba(16, 185, 129, 0.4);\n}\n\n/* Product Page Specific Styles */\n.product-image {\n  border-radius: 1rem;\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);\n  transition: all 0.3s ease;\n}\n\n.product-image:hover {\n  transform: scale(1.02);\n}\n\n/* Payment Page Specific Styles */\n.payment-card {\n  background: rgba(17, 17, 17, 0.8);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1rem;\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);\n}\n\n/* Form Inputs */\n.form-input {\n  background: rgba(15, 31, 15, 0.8);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  color: white;\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  transition: all 0.2s;\n}\n\n.form-input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);\n  outline: none;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(17, 17, 17, 0.7);\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(45deg, #059669, #0d9488);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(45deg, #0d9488, #059669);\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.hide-scrollbar {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n/* Stats Card Animation */\n.stats-card {\n  transition: all 0.3s ease;\n  background: rgba(17, 17, 17, 0.7);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.stats-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(16, 185, 129, 0.3);\n  box-shadow: 0 8px 32px rgba(16, 185, 129, 0.2);\n}\n\n/* Social Links Animation */\n.social-link {\n  transition: all 0.3s ease;\n}\n\n.social-link:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* Feature Text Color */\n.feature-text {\n  color: #22c55e;\n}\n\n/* Price Text Color */\n.price-text {\n  @apply text-[#22c55e] font-bold;\n}\n\n/* Link Color */\n.link-text {\n  color: #22c55e;\n  transition: all 0.3s ease;\n}\n\n.link-text:hover {\n  color: #15803d;\n  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
